import React from 'react'
import { Container } from './styles'

interface ToggleProps {
    title?: string
    titleComponent?: JSX.Element
    value: boolean
    onChange: (value: boolean) => void
}
const Toggle = ({ title, titleComponent, value, onChange }: ToggleProps): JSX.Element => {
    return (
        <Container>
            <label className="toggle_switch">
                <input
                    className={'toggle_input'}
                    onChange={() => onChange(!value)}
                    defaultChecked={value}
                    checked={value}
                    type="checkbox"
                />
                <span className="toggle_slider"></span>
            </label>
            {title ? <label className={'toggle_label'}>{title}</label> : null}
            {!title && titleComponent ? <div className={'toggle_label'}>{titleComponent}</div> : null }
        </Container>
    )
}

export default Toggle
